import UserProfile from 'api/types/auth/UserProfile.interface';
import UserRoles from 'api/types/auth/UserRoles.enum';

export const getUserPermissions = (profile: UserProfile) => ({
  read: profile.roles.includes(UserRoles.STUFF_PORTAL),
  write: profile.roles.includes(UserRoles.STUFF_PORTAL_WRITE),
});
